import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { DataInputs, IBRMInputDataRequiredInput } from 'src/common/api/brm/brm-utils';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import DateInput from './components/date-input/date-input';
import TextInput from './components/text-input/text-input';
import { styles } from './input-data-required-styles';
import { ReactComponent as DecisionTakingIcon } from 'src/common/media/DecisionTaking.svg';
import NumericInput from './components/numeric-input/numeric-input';
import EmeraldDialog from '../../../common/components/emerald-dialog/emerald-dialog';
import { useTranslation } from 'react-i18next';

type Props = IInputDataRequiredState;

export const showInputDataRequiredDialog = (props: Props, modalId?: string): void => {
  pushEmeraldModal(<InputDataRequiredModal {...props} />, undefined, modalId);
};

export const InputDataRequiredModal: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles();
  const {
    caption,
    captionKey,
    message,
    messageKey,
    type,
    onAccept,
    onCancel,
    fullScreen,
    titleKey,
  } = props;
  const { t } = useTranslation();

  const getTitle = () => (titleKey ? t(titleKey) : t('DataRequired'));
  const getCaption = () => (captionKey ? t(captionKey) : caption || '');
  const getMessage = () => (messageKey ? t(messageKey) : message || '');

  const getByInputType = (inputType: DataInputs): JSX.Element => {
    switch (inputType) {
      case DataInputs.Birthday:
      case DataInputs.Date:
        return (
          <DateInput
            caption={getCaption()}
            message={getMessage()}
            onAccept={onAccept}
            onCancel={onCancel}
            isDateOfBirth={type === DataInputs.Birthday}
            inputName={props.inputName}
            inputLabel={props.inputLabel}
          />
        );
      case DataInputs.Numeric:
        return (
          <NumericInput
            caption={getCaption()}
            message={getMessage()}
            onAccept={onAccept}
            onCancel={onCancel}
            isAllowPrecision={props.isAllowPrecision}
            inputName={props.inputName}
            inputLabel={props.inputLabel}
          />
        );
      case DataInputs.Text:
        return (
          <TextInput
            caption={getCaption()}
            message={getMessage()}
            onAccept={onAccept}
            onCancel={onCancel}
            inputName={props.inputName}
            inputLabel={props.inputLabel}
            fullScreen={fullScreen}
          />
        );
      default:
        return <></>;
    }
  };

  const modal = getByInputType(type);
  if (type === DataInputs.Text) {
    return modal;
  }
  return (
    <EmeraldDialog
      open={true}
      fullWidth
      data-testid='input-data-required'
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <Grid container direction='column' className={classes.mainContainer}>
        <Grid item className={classes.title}>
          <Typography className={classes.titleContent}> {getTitle()}</Typography>
          <DecisionTakingIcon />
        </Grid>
        <Grid item container direction='row' className={classes.mainContent}>
          {modal}
        </Grid>
      </Grid>
    </EmeraldDialog>
  );
};

export interface IInputDataRequiredState {
  type: DataInputs;
  caption?: string;
  message?: string;
  captionKey?: string;
  messageKey?: string;
  onCancel: () => void;
  onAccept: (inputData: string | IBRMInputDataRequiredInput) => void;
  inputName?: string;
  inputLabel?: string;
  fullScreen?: boolean;
  titleKey?: string;
  isAllowPrecision?: boolean;
}
